import b from 'b_';
import cx from 'classnames';
import { SimpleCallback } from 'platform-components/common';
import React, { ReactNode } from 'react';

import { CalendarPlanShowcaseCarouselNextCardLabel } from '../__carousel-next-card-label/calendar-plan-showcase__carousel-next-card-label';
import { CalendarPlanShowcaseCarouselHeaderSize } from '../typings';

import './calendar-plan-showcase__carousel-header.scss';

interface Props {
    children?: ReactNode;
    showNextLabel?: boolean;
    onNextLabelClick?: SimpleCallback;
    mix?: string;
    size?: CalendarPlanShowcaseCarouselHeaderSize;
}

export const CalendarPlanShowcaseCarouselHeader = ({
    children,
    showNextLabel,
    onNextLabelClick,
    mix,
    size = CalendarPlanShowcaseCarouselHeaderSize.M,
}: Props) => (
    <div className={cx(b('calendar-plan-showcase', 'carousel-header'), mix)}>
        <div className={b('calendar-plan-showcase', 'carousel-header-content')}>{children}</div>
        {showNextLabel ? <CalendarPlanShowcaseCarouselNextCardLabel onClick={onNextLabelClick} size={size} /> : null}
    </div>
);

CalendarPlanShowcaseCarouselHeader.SIZE = CalendarPlanShowcaseCarouselHeaderSize;
